import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-cancel-loan-contract',
  templateUrl: './cancel-loan-contract.component.html',
  styleUrls: ['./cancel-loan-contract.component.scss']
})
export class CancelLoanContractComponent implements OnInit {

  @Input() contractData: any
  @ViewChild('closeBtn') closeBtn: ElementRef;
  errorMsg: boolean;

  role: any;

  constructor(private appComp: AppComponent, private authService: AuthenticationService, private router: Router) { }

  ngOnInit(): void {

    this.role = this.authService.getUserRole();
  }

  cancelContract(){
    this.appComp.loading = true;
    this.errorMsg = false;
    let contractUpdate ={
      ...this.contractData
    }
    contractUpdate.active = false;
    
    console.log(contractUpdate);
    //stringify
    let keys = Object.keys(contractUpdate);
    keys.forEach((key, index) => {
      if(typeof contractUpdate[key] == 'object'){
        // console.log(key + " is type: " + typeof contractUpdate[key]);
        let string =  JSON.stringify(contractUpdate[key]);
        if(string[0] == "{" || string[0] == "["){
          contractUpdate[key] = JSON.stringify(contractUpdate[key]);
        }
        
      }
    });
    console.log(contractUpdate);

    this.authService.updateLoanContract(contractUpdate).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.appComp.loading = false;
      this.router.navigateByUrl('/loans/contracts');
    }, err=>{
      console.log(err);
      this.appComp.loading = false;
      this.errorMsg = true;
    })
  }

}
